function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useGiveawayStore from '@/stores/GiveawayStore';
import { UserLevels } from '@/types/server';
import React from 'react';
import { useShallow } from 'zustand/react/shallow';
import SettingsPanel from '../SettingsPanel';
import { NumberInput } from '@mantine/core';
import { getUserLevelValue } from '@/utils/userlevel';
import styles from './GiveawayLuckSettings.module.scss';
import AdvancedRevealButton from '../AdvancedRevealButton';
import { useDisclosure } from '@mantine/hooks';
import useIntlMemo from '@/hooks/useIntlMemo';
var MAX_LUCK = 10;
var MIN_LUCK = 1;
export default function GiveawayLuckSettings() {
    var _useGiveawayStore = useGiveawayStore(useShallow(function(state) {
        return {
            luck: state.luck,
            eligibility: state.eligibility,
            setLuck: state.setLuck
        };
    })), luck = _useGiveawayStore.luck, setLuck = _useGiveawayStore.setLuck, eligibility = _useGiveawayStore.eligibility;
    var hasChangedValues = eligibility.map(function(userLevel) {
        return luck[userLevel];
    }).some(function(value) {
        return value !== 1;
    });
    var _useDisclosure = _sliced_to_array(useDisclosure(hasChangedValues), 2), advancedOpen = _useDisclosure[0], advancedHandlers = _useDisclosure[1];
    var UserLevelHeadingMapping = useIntlMemo(function(intl) {
        var _obj;
        return _obj = {}, _define_property(_obj, UserLevels.EVERYONE, intl.formatMessage({
            id: "cxlCgf",
            defaultMessage: [
                {
                    type: 0,
                    value: "Viewer Luck Modifier"
                }
            ]
        })), _define_property(_obj, UserLevels.REGULAR, intl.formatMessage({
            id: "aTWC0W",
            defaultMessage: [
                {
                    type: 0,
                    value: "Regular Luck Modifier"
                }
            ]
        })), _define_property(_obj, UserLevels.SUBSCRIBER, intl.formatMessage({
            id: "OaiPjX",
            defaultMessage: [
                {
                    type: 0,
                    value: "Subscriber Luck Modifier"
                }
            ]
        })), _define_property(_obj, UserLevels.MODERATOR, intl.formatMessage({
            id: "GkdDhG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Moderator Luck Modifier"
                }
            ]
        })), _define_property(_obj, UserLevels.TWITCH_VIP, intl.formatMessage({
            id: "iLQQ0m",
            defaultMessage: [
                {
                    type: 0,
                    value: "VIP Luck Modifier"
                }
            ]
        })), _define_property(_obj, UserLevels.SOOP_VIP, intl.formatMessage({
            id: "iLQQ0m",
            defaultMessage: [
                {
                    type: 0,
                    value: "VIP Luck Modifier"
                }
            ]
        })), _obj;
    }, []);
    var handleLuckChange = function(userLevel, value) {
        value = typeof value === 'number' ? value : parseInt(value, 10);
        if (value < MIN_LUCK || isNaN(value) || value == null) {
            value = MIN_LUCK;
        } else if (value > MAX_LUCK) {
            value = MAX_LUCK;
        }
        setLuck(userLevel, value);
    };
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(AdvancedRevealButton, {
                    open: advancedOpen,
                    onClick: advancedHandlers.toggle
                })
            }),
            advancedOpen ? eligibility.sort(function(a, b) {
                return getUserLevelValue(a) - getUserLevelValue(b);
            }).map(function(userLevel) {
                return /*#__PURE__*/ _jsx(SettingsPanel, {
                    className: styles.settingsPanel,
                    heading: UserLevelHeadingMapping[userLevel],
                    afterElement: /*#__PURE__*/ _jsx(NumberInput, {
                        min: MIN_LUCK,
                        max: MAX_LUCK,
                        clampBehavior: "strict",
                        leftSection: "x",
                        className: styles.numberInput,
                        variant: "outline",
                        value: luck[userLevel],
                        onChange: function(value) {
                            return handleLuckChange(userLevel, value);
                        }
                    })
                }, userLevel);
            }) : null
        ]
    });
}
